(() => {
  const cleanVariantLabel = (value) => value.split(/\s*-\s*ETA\b/i)[0].trim();

  const updateCollectionCardImage = (swatch) => {
    const imageSource = swatch?.dataset.variantImage;
    const card = swatch?.closest('.m-product-card');
    const image = card?.querySelector('.m-product-card__image img');

    if (!imageSource || !image) return;

    image.src = imageSource;
    image.removeAttribute('srcset');
    image.dataset.variantImage = 'true';

    const media = image.closest('.m-product-card__media');
    media?.classList.add('m-product-card--variant-image-selected');

    card?.querySelectorAll('.m-product-card__swatch.is-selected').forEach((item) => {
      item.classList.remove('is-selected');
    });
    swatch.classList.add('is-selected');
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.m-variants__input');

    if (!input) return;

    const selectedValue = input.closest('.m-variants__fieldset')?.querySelector('[data-selected-value]');

    if (!selectedValue) return;

    requestAnimationFrame(() => {
      selectedValue.textContent = cleanVariantLabel(input.value);
    });
  });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.m-product-card__swatch[data-variant-image]');

    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();
    updateCollectionCardImage(swatch);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const swatch = event.target.closest('.m-product-card__swatch[data-variant-image]');

    if (!swatch) return;

    event.preventDefault();
    swatch.click();
  });
})();
